import React , {useState} from 'react';
import PropTypes from 'prop-types';
import { Accordion } from 'react-bootstrap-accordion';

Faqs.propTypes = {
    data: PropTypes.array
};

function Faqs(props) {

    const {data} =props;

    const [dataBlock] = useState(
        {
            subheading: 'FAQs',
            heading: 'Frequently Aksed Questions',
            desc1: "Below is a list of frequently asked questions and answers related to PipPlus Tech's trading systems.",
    desc2: 'Please check this FAQ before reaching out to our support team.'
            
        }
    )

    return (
        <section className="faq">
            <div className="shape right"></div>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="block-text center" data-aos="fade-down" data-aos-duration="3000">
                            <h6 className="sub-heading"><span>{dataBlock.subheading}</span></h6>
                            <h3 className="heading">{dataBlock.heading}</h3>
                                <p className="mb-17">{dataBlock.desc1}</p>
                                <p>{dataBlock.desc2}</p> 
                        </div>

                        <div className="faq__main">
  <div className="flat-accordion">
    {data.map(item => (
      <Accordion show={item.show} key={item.id} title={item.title} className="flat-toggle h6">
        <p className="toggle-content">{item.text}</p>
      </Accordion>
    ))}
  </div>
</div>

                    </div>

                </div>
            </div>
        </section>
    );
}

export default Faqs;
